import React from 'react';
import PropTypes from 'prop-types';
import {Button, Link, Stack} from '@customink/pigment-react';

import Notification from '~/components/Notification';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function DeleteSleeveDesignWarning(props) {
  const {dismiss, notification} = props;

  const handleDeleteSleeveDesign = () => {
    notification.payload?.handleConfirmDeletion();
    dismiss();
  };

  return (
    <Notification dismiss={dismiss} title="Remove this product?" type="ERROR">
      <br />
      <p className="ndx-cta1">This will also remove the sleeve design.</p>
      <Stack className="notification-stack">
        <Button
          className="notification-cta"
          size="large"
          variant="secondary"
          onClick={handleDeleteSleeveDesign}>
          Yes, Remove Product
        </Button>
        <p className="ndx-cta1">
          <Link button variant="uiTextSmall" onClick={dismiss}>
            Cancel
          </Link>
        </p>
      </Stack>
    </Notification>
  );
}

const propTypes = {
  dismiss: PropTypes.func,
  notification: PropTypes.shape({
    payload: PropTypes.shape({
      handleConfirmDeletion: PropTypes.func
    })
  })
};

DeleteSleeveDesignWarning.propTypes = propTypes;

DeleteSleeveDesignWarning.displayName = 'DeleteSleeveDesignWarning';
